export default __webpack_public_path__ + "static/Tip-5-Bring-a-good-book-072d08a1d4e0b5e89b5833f7ae2a2952.jpg";